import React, { useEffect, useState } from 'react';
import Modal from '../../components/modal/modal.component';
import Card from '../../components/card.component';
import utils from '../../utils/utils.functions';

const resetParams = {
    observacion: '',
    confirmar_email: false,
}

const ConfirmaBoleta = ({ show, onClose, onConfirm, monto, backDrop = true }) => {
  
  const [params, setParams] = useState({
      observacion: '',
      confirmar_email: false,
  });

  useEffect(() => {
    if (!show) {
        setParams(resetParams) 
    }
  },[show]);
 
  const handleChange = () => {
    setParams({
        ...params,
        confirmar_email: !params.confirmar_email,
    });
  };

  const observacionChangeText = (ev) => {
    setParams({
        ...params,
        observacion: ev.target.value,
    });
  }

  const Checkbox = ({ label, value, onChange }) => {
    return (
      <label>
        <input type="checkbox" checked={value} onChange={onChange} className="mr-2" />
        {label}
      </label>
    );
  };
  
  return (
    <Modal size="lg" show={show} backDrop={backDrop}>
      <Card>
          <div>
            <h4>Confirma generar el recibo de pago por:</h4>
            <div className="boleta-price">${utils.formatMoney(monto, 0, ',', '.')}</div>
          </div>
          <div>
            <div className="grupo-input">
                <small>¿Incluir alguna observación?</small>
                <textarea className={`form-control input-border`} name="observacion" rows={3} onChange={observacionChangeText}>
                </textarea>
            </div>
          </div>
          <div className="mt-2">
            <div className="grupo-input">
                <Checkbox
                    label="¿Enviar recibo al correo del cliente?"
                    value={params.confirmar_email}
                    onChange={handleChange}
                />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button
                onClick={onClose}
                type="button"
                className="btnx btnx-warn mr-2"
                style={{ backgroundColor: 'rgb(252, 45, 45)' }}
            >
                Cancelar
            </button>
            <button
                onClick={() => onConfirm(params)}
                type="button"
                className="btnx btnx-warn"
            >
                Confirmar
            </button>
          </div>
      </Card>
    </Modal>
  )
}

export default ConfirmaBoleta;